import { BrandUtils, LazyLoadUtils } from "../../utils/index.js";

const loyaltySectionCache = new Map();

export const loadLoyaltySection = (brandId, clientProvider) => {
  const dynamicPart = `${brandId}/${clientProvider}/`;

  if (!loyaltySectionCache.has(dynamicPart)) {
    loyaltySectionCache.set(
      dynamicPart,
      LazyLoadUtils.lazyWithFallback(
        () =>
          import(
            /* webpackChunkName: "[request]" */
            `../Brands/${dynamicPart}LoyaltySection.layout.js`
          ),
        { componentName: "loadLoyaltySection" }
      )
    );
  }

  return loyaltySectionCache.get(dynamicPart);
};

export const preload = ({ clientProvider, brandId }) => {
  if (BrandUtils.isPokerClient())
    loadLoyaltySection(brandId, clientProvider)?.preload();
};
